import React, { FunctionComponent } from 'react';
import { Box, CssBaseline, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';

import { backdropImageUrl } from '@paragon/client-tools';
import { isUsingCustomTheme, LoginContainer } from '@paragon/login-tools';
import { Notifier, NotifierDialog } from '@paragon/notification-tools';
import { ThemedLogo } from '@paragon/themes';

import { useStartApp } from '../../actions/startApp';
import { useAppSelector } from '../hooks';
import { Content } from './Content';
import { Header } from './Header';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': { color: 'white' },
}));

export const RootComponent: FunctionComponent = () => {
  const startApp = useStartApp();
  const usingCustomTheme = useAppSelector(isUsingCustomTheme);

  return (
    <>
      <CssBaseline />
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        maxSnack={3}
        Components={{
          default: StyledMaterialDesignContent,
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent,
        }}
      >
        <Box
          sx={{
            position: 'fixed',
            display: 'flex',
            flexDirection: 'column',

            // TODO: allow pages to choose between document and application layout?
            // position: 'fixed',

            width: '100%',
            height: '100%',
            top: 0,
            backgroundImage: `url(${backdropImageUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundAttachment: 'fixed',
          }}
        >
          <Notifier />
          <NotifierDialog />
          <LoginContainer
            onLogIn={startApp}
            requirePermission="materials-access"
            logoOverride={(usingCustomTheme && <ThemedLogo width={300} />) || undefined}
          >
            <Header />
            <Content />
          </LoginContainer>
        </Box>
      </SnackbarProvider>
    </>
  );
};
